import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { LoginService } from './login.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent{

  public formSubmitted = false;

  public loginForm = this.fb.group({
    usuario: [ '', Validators.required ],
    clave: ['' , Validators.required],
  });

  constructor(private router: Router,
              private fb: FormBuilder,
              private loginService: LoginService) {

                  if (!environment.production) {
                    this.router.navigate(['/menu/resumen']);
                  }else{
                    localStorage.clear();
                  }
              }
  onLogin() {

    this.formSubmitted = true;

    let usuario: string = this.loginForm.get('usuario').value;


    this.loginForm.get('usuario').setValue(usuario.toUpperCase());

    console.log(this.loginForm.value);


    if (this.loginForm.invalid) {
      console.log('El formulario no es correcto');
      Swal.fire('Error', 'Debe completar todos los campos', 'error');
      return;
    }
    this.loginService.loginUser(this.loginForm.value)
    .subscribe ( resp => {
      console.log(resp);
      if (resp.datos.length) {
        this.router.navigate(['/menu/resumen']);
      } else {
        if (resp.datos === ''){
          this.router.navigate(['/reset']);
        }else{
          Swal.fire('Alerta', resp.mensaje.error , 'error');
        }
      }
    }, (err) => {
      console.log(err);
      Swal.fire('Alerta', 'Error de ingreso', 'error');
    });
  }
}
